import type { EcommerceApc } from '../types/newProductCard.type';
import { availabilityDictionaryByStatus } from '../../../../../../utils/middleware-pipe/pipes/e-commerce/e-commerce-status-dictionary';
import type {UcItem} from '../../../utils/ucOptions';
import {formatDate} from '../../../../result-cards/utils/DateFormatter';
import {getLocaleCode} from '../../../../../../helpers/locale';

export const getEcommerceData = (
  id: string,
  productIds: EcommerceApc['availibilityInfo'],
  eShopUrl: string
): EcommerceApc => {
    const availibilityInfo = productIds.filter((p) => p.id === id);
    const viewConfiguration =
    availabilityDictionaryByStatus[availibilityInfo[0]?.availabilityStatus];

    return {
      price: availibilityInfo[0]?.price,
      availibilityInfo,
      viewConfiguration,
      eShopUrl,
    };
};

export const getRangesCombinedTerm = (ranges, category, allowRangeCategory = false): string => {
    if (ranges !== undefined && (category === 'Product' || (allowRangeCategory && category === 'Product Range'))) {
      const rangesArray = ranges instanceof Array ? ranges : [ranges];

      if (rangesArray?.some((obj) => 'key' in obj)) {
        return rangesArray
          ?.map((item) => item.key)
          .join(' ')
          .trim();
      }

      return '';
    }

    return '';
};

export enum ResultCardType {//eslint-disable-line @stencil-community/ban-exported-const-enums
  Product = 'Product',
  ProductAPC = 'ProductAPC',
  Basic = 'Basic',
  Document = 'Document',
  Dropdown = 'dropdown-cta'
}

export const getWcEventData = (eventName: string, country: string, language: string, id: string) => {
    return {
      'type': 'easy',
      'payload': {
        'data': {
          'event': eventName,
          'source': 'SE SRP'
        },
        'bom': {
          'country': country.toUpperCase(),
          'locale': `${language}-${country?.toUpperCase()}`,
          'products': [
            {
              'partType': 'nonCto',
              'productId': id,
              'quantity': 1,
              'applicationSource': 'Search',
              'subparts': []
            }
          ]
        }
      }
    };
};

export const getGAEventData = (eventName: string, items: Array<UcItem>, location: string, currency?: string, value?: string ) => {
    return {
      eventName: eventName,
      currency: currency,
      value: value,
      location: location,
      items: items
    };
};

export const getValidatedPrice = (price) => {
    if (!price) return '';
    if (typeof price === 'string') {
      const priceValue = parseFloat(price);
      if (priceValue > 0) return priceValue;
    }
    if (typeof price === 'number') return price;
    return '';
};

export const getStatus = (commStatus:string, isAdditional:boolean = false) => {
    switch (commStatus) {
    case '14':
    case '05':
      return 'warning';
    case '16':
      if(isAdditional) return 'error';
      return 'warning';
    case '03':
    case '18':
    case '19':
      return 'error';
    default:
      return 'success';
    }
};

export const addOneDayToISOString = (dateString: string): string => {
    if(!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    date.setUTCDate(date.getUTCDate() + 1);
    return date.toISOString().split('.')[0] + 'Z';
};

export const getDatePlusOneDay = (dateString: string, language: string, country: string): string => {
    if (!dateString) return '';
    const datePlusOneISOString = addOneDayToISOString(dateString);
    if (!datePlusOneISOString) return '';
    const localeCode = getLocaleCode({language: language, country: country});
    return formatDate(datePlusOneISOString, localeCode);
};